<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-cliente') {
            next({ name: 'ven-cliente-list', replace: true });
        } else if (to.name == 'agro-cliente') {
            next({ name: 'agro-cliente-list', replace: true });
        } else if (to.name == 'pro-cliente') {
            next({ name: 'pro-cliente-list', replace: true });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-cliente') {
            this.$router.replace({ name: 'ven-cliente-list' });
        } else if (this.$route.name == 'agro-cliente') {
            this.$router.replace({ name: 'agro-cliente-list' });
        } else if (this.$route.name == 'pro-cliente') {
            this.$router.replace({ name: 'pro-cliente-list' });
        }
    },
};
</script>
